import React, { useState } from 'react';
import { IconButton, Box } from '@material-ui/core';
import { useSelector } from 'dva';
import CloseIcon from '@material-ui/icons/CloseTwoTone';
import DataTableNativeML from '@/components/DataTableNativeML';
import ModalML from '@/components/ModalML/NewModalML';
import webStorage from '@/utils/storageManager';
import { getToken } from '@/utils/token';
import ResultListStyled from './ResultListStyled';

const ResultList = (props) => {
  const MESSAGE_MY_TASK_TYPE = webStorage.get('DICTOBJ')?.MESSAGE_MY_TASK_TYPE;
  const { pageData } = props;
  const { handlePageChange } = props;
  const loadingEffect = useSelector((state) => state.loading);
  const listLoading = loadingEffect.effects['myTask/getTaskList'];

  const { taskList, total } = useSelector((state) => state.myTask) || {};
  const [modalData, setModelData] = useState();
  const [open, setOpen] = useState(false);

  const columns = [
    {
      align: 'center',
      title: '任务名称',
      id: 'taskName',
      key: 'taskName',
      width: '188',
    },
    {
      title: '模块',
      align: 'center',
      id: 'module',
      key: 'module',
      width: '120',
    },
    {
      title: '类型',
      id: 'type',
      key: 'type',
      align: 'center',
      width: '120',
      render: (row) => {
        return MESSAGE_MY_TASK_TYPE.find((item) => item.dictValue === row.type)
          ?.nameZh;
      },
    },
    {
      title: '开始时间',
      id: 'startTime',
      key: 'startTime',
      align: 'center',
      width: '180',
    },
    {
      title: '结束时间',
      id: 'finishTime',
      key: 'finishTime',
      align: 'center',
      width: '180',
    },
    {
      title: '状态',
      id: 'statusName',
      key: 'statusName',
      align: 'center',
      width: '120',
    },
    {
      title: '状态说明',
      id: 'statement',
      key: 'statement',
      align: 'center',
    },
    {
      title: '操作',
      align: 'center',
      id: 'mobile',
      key: 'mobile',
      width: 224,
      render: (rowInfo) => {
        const status = rowInfo.status; //3是完成
        const type = rowInfo.type; // 1下载 2任务
        const statement = rowInfo.statement; //成功 失败  警告
        let buttonList = [];
        if (status === 3) {
          //完成的任务下面才有按钮
          if (type === 1) {
            // 下载下
            if (statement === '成功') {
              buttonList = [{ name: '下载', type: 'download' }];
            } else if (statement === '警告') {
              buttonList = [
                { name: '警告原因', type: 'modal', download: true },
                { name: '下载', type: 'download' },
              ];
            } else {
              buttonList = [
                { name: '失败原因', type: 'modal', download: true },
              ];
            }
          } else if (statement === '成功') {
            buttonList = [{ name: '结果', type: 'modal', download: false }];
          } else if (statement === '警告') {
            buttonList = [{ name: '警告原因', type: 'modal', download: true }];
          } else {
            buttonList = [{ name: '失败原因', type: 'modal', download: true }];
          }
        }
        const mData = {
          warningReason: rowInfo.warningReason,
          fileUrl: rowInfo.fileUrl,
        };
        return (
          <Box
            display="flex"
            gap="0 15px"
            justifyContent="center"
            alignItems="center"
          >
            {buttonList.map((item, index) => (
              <>
                <Box
                data-log={JSON.stringify({
                  oid: 'btn_my_task_download',
                  events: ['_ev', '_ec'],
                  params: {
                    task_id: rowInfo.id,
                  },
                })}
                  sx={{
                    fontSize: '14px',
                    color: '#1B60AD',
                    lineHeight: '20px',
                    cursor: 'pointer',
                  }}
                  key={item.name}
                  onClick={() => {
                    if (item.type === 'download') {
                      handleDownLoad(rowInfo.fileUrl);
                    } else {
                      setModelData({
                        ...mData,
                        title: item.name,
                        download: item.download,
                      });
                      handleClick();
                    }
                  }}
                >
                  {item.name}
                </Box>
                {buttonList.length === 2 && index === 0 && (
                  <Box
                    sx={{ height: '14px', width: '1px', background: '#1B60AD' }}
                  ></Box>
                )}
              </>
            ))}
          </Box>
        );
      },
    },
  ];
  //下载
  const handleClick = () => {
    setOpen(true);
  };

  //弹框
  const handleDownLoad = (fileUrl) => {
    const apiToken = `${getToken()}`;
    const a = document.createElement('a');
    // a.download = filename;
    a.href = `${
      window.location.origin
    }/bizgrowth/web/v1/common/download?uri=${encodeURIComponent(
      fileUrl,
    )}&access_token=${apiToken}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  //换页
  const changePage = ({ pageNum, pageSize }) => {
    handlePageChange({ ...pageData, pageNum, pageSize });
  };

  //关闭modal
  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <ResultListStyled>
      <DataTableNativeML
        columns={columns}
        loading={listLoading}
        changePage={changePage}
        page={pageData}
        data={taskList}
        devicesMinWidth={1640}
        total={total}
        paging={true}
        columnKey="id"
      ></DataTableNativeML>
      <ModalML open={open} setOpen={setOpen} onCancel={handleCancel}>
        <Box sx={{ padding: '0 32px 22px 32px' }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box
              sx={{
                fontSize: '18px',
                color: '#212121',
                fontWeight: '500',
                lineHeight: '25px',
              }}
            >
              {modalData?.title}
            </Box>
            <IconButton
              aria-label="close"
              onClick={() => handleCancel()}
              sx={{ padding: 0 }}
            >
              <CloseIcon sx={{ width: '25px', height: '25px' }} />
            </IconButton>
          </Box>
          <Box
            sx={{
              marginTop: '24px',
              width: '480px',
              height: '340px',
              borderRadius: '4px',
              border: '1px solid #1565C0',
              padding: '12px 16px',
              overflowY: 'scroll',
              fontSize: '14px',
              color: '#212121',
              lineHeight: '20px',
            }}
          >
            {modalData?.warningReason}
          </Box>
          {modalData?.download && modalData?.fileUrl && (
            <Box
              sx={{
                marginTop: '24px',
                fontSize: '14px',
                color: '#212121',
                lineHeight: '20px',
              }}
            >
              点击
              <span
                style={{ color: '#1565C0', cursor: 'pointer' }}
                onClick={() => handleDownLoad(modalData?.fileUrl)}
              >
                下载{' '}
              </span>
              查看详情
            </Box>
          )}
        </Box>
      </ModalML>
    </ResultListStyled>
  );
};
export default ResultList;
